var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMenuConversation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.4788 14.5741L20.4788 14.574L20.4741 14.5788C19.8428 15.2186 18.9088 15.6 17.75 15.6H17.25V16.1V17.91C17.25 18.1983 16.9309 18.3557 16.7107 18.2063L16.7108 18.2062L16.7054 18.2027L16.025 17.7537C16.0702 17.499 16.09 17.2361 16.09 16.97V12.9C16.09 11.7664 15.7099 10.7829 15.0086 10.0815C14.3072 9.38006 13.3236 9 12.19 9H5.5V6.75C5.5 5.58862 5.88494 4.65966 6.5223 4.0223C7.15966 3.38494 8.08862 3 9.25 3H17.75C18.9114 3 19.8403 3.38494 20.4777 4.0223C21.1151 4.65966 21.5 5.58862 21.5 6.75V11.85C21.5 13.0088 21.1186 13.9428 20.4788 14.5741Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9798 17.8406L14.9773 17.8492L14.9751 17.8579C14.6665 19.0841 13.664 19.87 12.19 19.87H9.47H9.31882L9.19297 19.9538L6.17296 21.9638L6.17293 21.9637L6.16634 21.9683C6.06086 22.0409 5.89999 21.9728 5.89999 21.82V20.37V19.87H5.39999C4.493 19.87 3.77678 19.5697 3.29356 19.0864C2.79956 18.5925 2.5 17.8757 2.5 16.97V12.9C2.5 12.0553 2.76075 11.3764 3.19077 10.8939C3.61939 10.413 4.2461 10.0935 5.04255 10.0182C5.17296 10.0082 5.28332 10 5.39999 10H12.19C13.0964 10 13.8128 10.2999 14.3014 10.7886C14.7901 11.2772 15.09 11.9936 15.09 12.9V16.97C15.09 17.2942 15.0538 17.5857 14.9798 17.8406Z",
    fill: "white",
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMenuConversation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-menu-conversation.e5c1db54246605fd3d42672652872d2f.svg";